"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.virtualPageview = exports.trackingProvider = exports.track = exports.withTrack = void 0;
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("./index"));
var components_1 = require("./components");
/**
 * @ignore
 */
function hoistStaticsAndForwardRefs(Target, Source, displayName) {
    var forwardRef = function (props, ref) { return (react_1.default.createElement(Target, __assign({}, props, { forwardedRef: ref }))); };
    forwardRef.displayName = displayName + "(" + (Source.displayName || Source.name) + ")";
    return hoist_non_react_statics_1.default(react_1.default.forwardRef(forwardRef), Source);
}
/**
 * @description Decorator that provides a `track` prop to your component which
 * references {@linkcode SegmentSDKWrapper.track}. Track calls made by invoking
 * this `track` prop value will include the current tracking context properties
 * provided by {@linkcode TrackingProvider}. This can be used on components that
 * are contained within parents that use the {@linkcode trackingProvider}
 * decorator or the {@linkcode TrackingProvider} component.
 *
 * For functional components, use the {@linkcode useTrack} hook instead.
 *
 * @typeParam R The ref type of the wrapped component
 * @typeParam P The props type of the wrapped component
 *
 * Example:
 *
 * ```javascript
 * import React from 'react';
 * import { withTrack } from '@optimizely/segment-sdk-wrapper';
 *
 * @withTrack
 * class RolloutsDashboard extends React.Component {
 *   onRolloutLinkClick() {
 *     const { track } = this.props;
 *     track('click');
 *   }
 * }
 * ```
 *
 * @category Decorator
 */
exports.withTrack = function (Component) {
    var WithTrack = /** @class */ (function (_super) {
        __extends(WithTrack, _super);
        function WithTrack() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getTrack = function (properties) { return function (event, overrideProperties, options, callback) {
                index_1.default.track(event, __assign(__assign({}, properties), overrideProperties), options, callback);
            }; };
            return _this;
        }
        WithTrack.prototype.render = function () {
            var _this = this;
            var _a = this.props, forwardedRef = _a.forwardedRef, props = __rest(_a, ["forwardedRef"]);
            return (react_1.default.createElement(components_1.TrackingContext.Consumer, null, function (properties) { return (react_1.default.createElement(Component, __assign({}, props, { ref: forwardedRef, track: _this.getTrack(properties) }))); }));
        };
        return WithTrack;
    }(react_1.default.Component));
    return hoistStaticsAndForwardRefs(WithTrack, Component, "withTrack");
};
/**
 * @description Decorator to wrap your component with the {@linkcode Track}
 * component and binds it to the event name passed. This can
 * be used on components that are contained within parents that use the
 * {@linkcode trackingProvider} decorator or the {@linkcode TrackingProvider}
 * component.
 *
 * @typeParam R The ref type of the wrapped component
 * @typeParam P The props type of the wrapped component
 *
 * Example:
 *
 * ```jsx
 * import React from 'react';
 * import { track } from '@optimizely/segment-sdk-wrapper';
 *
 * @track('click')
 * class RolloutsDashboard extends React.Component {
 *   render() {
 *     return (
 *       <TrackedChildComponent>
 *         <TrackedGrandchildComponent />
 *         <TrackedGrandchildComponent />
 *         <TrackedGrandchildComponent />
 *       </TrackedChildComponent>
 *     );
 *   }
 * }
 * ```
 *
 * @category Decorator
 */
exports.track = function (eventName) { return function (Component) {
    var Tracked = /** @class */ (function (_super) {
        __extends(Tracked, _super);
        function Tracked() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Tracked.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, props = __rest(_a, ["forwardedRef"]);
            return (react_1.default.createElement(components_1.Track, { eventName: eventName },
                react_1.default.createElement(Component, __assign({}, props, { ref: forwardedRef }))));
        };
        return Tracked;
    }(react_1.default.Component));
    return hoistStaticsAndForwardRefs(Tracked, Component, "track");
}; };
/**
 * @description Decorator to wrap your component with the
 * {@linkcode TrackingProvider} component using the properties passed. This can
 * be used on components that contain children that use the {@linkcode track},
 * {@linkcode withTrack}, and {@linkcode trackingProvider} decorators as well as
 * the {@linkcode Track} and {@linkcode TrackingProvider} components.
 *
 * @typeParam R The ref type of the wrapped component
 * @typeParam P The props type of the wrapped component
 *
 * Example:
 *
 * ```jsx
 * import React from 'react';
 * import { trackingProvider, Track } from '@optimizely/segment-sdk-wrapper';
 *
 * @trackingProvider({ dashboard: 'rollouts' })
 * class RolloutsDashboard extends React.Component {
 *   render() {
 *     return (
 *       <Track>
 *         <TrackedChildComponent />
 *         <TrackedChildComponent />
 *       </Track>
 *     );
 *   }
 * }
 * ```
 *
 * @category Decorator
 */
exports.trackingProvider = function (properties) { return function (Component) {
    var TrackingProvided = /** @class */ (function (_super) {
        __extends(TrackingProvided, _super);
        function TrackingProvided() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        TrackingProvided.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, props = __rest(_a, ["forwardedRef"]);
            var propertiesToPass = typeof properties === "function" ? properties(props) : properties;
            return (react_1.default.createElement(components_1.TrackingProvider, { properties: propertiesToPass },
                react_1.default.createElement(Component, __assign({}, props, { ref: forwardedRef }))));
        };
        return TrackingProvided;
    }(react_1.default.Component));
    return hoistStaticsAndForwardRefs(TrackingProvided, Component, "trackingProvider");
}; };
/**
 * @description Decorator to track a virtual pageview when your component is
 * rendered using {@linkcode SegmentSDKWrapper.virtualPageview}. This can be
 * used on components that are contained within parents that use the
 * {@linkcode trackingProvider} decorator or the {@linkcode TrackingProvider}
 * component.
 *
 * @typeParam R The ref type of the wrapped component
 * @typeParam P The props type of the wrapped component
 *
 * Example:
 *
 * ```javascript
 * import React from 'react';
 * import { virtualPageview } from '@optimizely/segment-sdk-wrapper';
 *
 * @virtualPageview('dashboard', 'rollouts', 'flags')
 * class RolloutsDashboard extends React.Component {
 *   render() {
 *     return (
 *       ...
 *     );
 *   }
 * }
 * ```
 *
 * @category Decorator
 */
exports.virtualPageview = function (category, name, urlSuffix, properties, options, callback) { return function (Component) {
    var WithVirtualPageview = /** @class */ (function (_super) {
        __extends(WithVirtualPageview, _super);
        function WithVirtualPageview() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithVirtualPageview.prototype.componentDidMount = function () {
            index_1.default.virtualPageview(category, name, urlSuffix, __assign(__assign({}, this.context), properties), options, callback);
        };
        WithVirtualPageview.prototype.render = function () {
            return react_1.default.createElement(Component, __assign({}, this.props));
        };
        WithVirtualPageview.contextType = components_1.TrackingContext;
        return WithVirtualPageview;
    }(react_1.default.Component));
    return hoistStaticsAndForwardRefs(WithVirtualPageview, Component, "virtualPageview");
}; };
exports.default = {
    track: exports.track,
    trackingProvider: exports.trackingProvider,
    virtualPageview: exports.virtualPageview,
    withTrack: exports.withTrack,
};
